import qs from 'query-string';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import DocumentCollaboration from './DocumentCollaboration';
import { getDocumentCollaboration } from '../../actions/DocumentCollaborationActions';
import Loader from '../../components/CustomLoader';

const DocumentCollaborationContainer = ({
  location,
  loading,
  collaboration,
  getDocumentCollaboration,
}) => {
  const queryString = location.search;
  const params = qs.parse(queryString) || {};
  const { url } = useRouteMatch();

  useEffect(() => {
    if (params.action === 'close') {
      window.close();
      return;
    }

    const [clientPath] = window.location.href.split(url);

    getDocumentCollaboration({
      clientPath,
      ...params,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <DocumentCollaboration
      formAction={collaboration.OfficeFormAction}
      accessToken={collaboration.AccessTokenValue}
      accessTokenTtl={collaboration.AccessTokenTTLValue}
    />
  );
};

const mapStateToProps = (state) => ({
  loading: state.documentCollaboration.loading,
  collaboration: state.documentCollaboration.data,
});

const mapDispatchToProps = {
  getDocumentCollaboration,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentCollaborationContainer);
